import { getTheme } from "../components/Theme/Theme";

export const changeTheme = (dispatch, theme) => {
  dispatch({
    type: "SET_THEME",
    payload: getTheme(theme),
  });
};
